var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50613 14.6667H11.4928C13.3328 14.6667 14.0661 13.54 14.1528 12.1667L14.4995 6.66001C14.5928 5.22001 13.4461 4.00001 11.9995 4.00001C11.5928 4.00001 11.2195 3.76668 11.0328 3.40668L10.5528 2.44001C10.2461 1.83334 9.44613 1.33334 8.76613 1.33334H7.23946C6.55279 1.33334 5.75279 1.83334 5.44613 2.44001L4.96613 3.40668C4.77946 3.76668 4.40613 4.00001 3.99946 4.00001C2.55279 4.00001 1.40613 5.22001 1.49946 6.66001L1.84613 12.1667C1.92613 13.54 2.66613 14.6667 4.50613 14.6667Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.33334H9",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 12C9.19398 12 10.1673 11.0267 10.1673 9.83332C10.1673 8.63999 9.19398 7.66666 8.00065 7.66666C6.80732 7.66666 5.83398 8.63999 5.83398 9.83332C5.83398 11.0267 6.80732 12 8.00065 12Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bc0eeab8190acc2abdc94fc8282e5b05.svg";
export { ForwardRef as ReactComponent };